module.exports = __webpack_public_path__ + "static/media/red_circle_tick.5f7f341c.svg";